import { createTheme, DEFAULT_FONT_FAMILY } from "@s7/styles";
import { FONT_FAMILY } from "./fonts";
var family = "".concat(FONT_FAMILY, ", ").concat(DEFAULT_FONT_FAMILY);
export var theme = createTheme({
    typography: {
        variants: {
            text: { family: family },
            heading: { family: family },
        },
    },
});
